/* global google */

const image_grids = [...document.querySelectorAll('.image-grid-block')];
const maps = [...document.querySelectorAll('.map-block')];

image_grids.forEach((grid) => {
    const cells = [...grid.querySelectorAll('.image-grid__cell')];
    const lightbox = grid.querySelector('.image-grid__lightbox');
    const lightbox_append = grid.querySelector('.image-grid__lightbox-append');
    const lightbox_close = grid.querySelector('.image-grid__lightbox-close');

    cells.forEach((cell) => {
        cell.onclick = () => {
            const image_url = cell.dataset.image;
            const caption_text = cell.textContent;
            const image = document.createElement('img');
            const caption = document.createElement('p');

            image.src = image_url;
            caption.textContent = caption_text;

            // Fade in lightbox and display image
            document.body.style.overflow = 'hidden';
            lightbox_append.appendChild(image);
            lightbox_append.appendChild(caption);
            lightbox.style.display = 'flex';
        };
    });

    lightbox.onclick = (event) => {
        // if clicked away hide lightbox
        if (event.target === lightbox || event.target === lightbox_close) {
            document.body.style.overflow = 'auto';
            lightbox.style.display = 'none';

            // Remove children for re-render
            while (lightbox_append.firstChild) {
                lightbox_append.firstChild.remove();
            }
        }
    };
});

maps.forEach((map) => {
    const api_url = map.dataset.api;
    const initial_zoom = parseInt(map.dataset.zoom, 10);
    const initial_coordinates = {
        lat: parseFloat(map.dataset.latitude),
        lng: parseFloat(map.dataset.longitude)
    };
    const map_pin = {
        url: map.dataset.pin,
        size: new google.maps.Size(40, 40),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(20, 40),
        scaledSize: new google.maps.Size(40, 40)
    };
    const map_pin_alt = {
        url: map.dataset.pinalt,
        size: new google.maps.Size(40, 40),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(20, 40),
        scaledSize: new google.maps.Size(40, 40)
    };

    const gmap = new google.maps.Map(map, {
        center: initial_coordinates,
        zoom: initial_zoom
    });

    const infowindow = new google.maps.InfoWindow();

    fetch(`/${api_url}`)
        .then((response) => response.json())
        .then((data) => {
            const locations = data.items;
            const bounds = new google.maps.LatLngBounds();

            locations.forEach((location) => {
                const marker = new google.maps.Marker({
                    position: {
                        lat: location.latitude,
                        lng: location.longitude
                    },
                    title: location.title,
                    map: gmap,
                    icon: Math.random() >= 0.5 ? map_pin : map_pin_alt
                });

                marker.addListener('click', () => {
                    infowindow.setContent(`
                        <h3>${location.title}</h3>
                        <p>${location.summary_for_map_page}</p>
                        <a href="${location.meta.html_url}" class="button">
                            Read more
                        </a>
                    `);
                    infowindow.open(gmap, marker);
                });

                const marker_location = new google.maps.LatLng(
                    marker.position.lat(),
                    marker.position.lng()
                );
                bounds.extend(marker_location);
            });

            gmap.fitBounds(bounds);
            gmap.panToBounds(bounds);
        });
});



// WEBPACK FOOTER //
// ./static/src/js/main.js